'use strict';

import CmpVendorScriptLoader from './components/CmpVendorScriptLoader';
import TrackingService from './components/TrackingService';
import NavigationHandler from './components/NavigationHandler';
import CommonMethods from './components/CommonMethods';
import Emitter from './components/Emitter';
import Form from './components/Form';
import WebAuthn from './components/WebAuthn';
import { OldieAntenneColorRotation } from './components/OldieAntenneColorRotation';
import BrushHeadlines from './components/BrushHeadlines';

// Fallbacks for JS Bridge Navive/Webview
window.nativeJsBridge = window.nativeJsBridge || {
    isWebview: false,
    async callHandlerIfWebview () {},
    callHandler (a, b) {
        // eslint-disable-next-line max-len
        throw new Error('This is not a webview! Before calling callHandler, please check `window.nativeJsBridge.isWebview`!');
    },
};
window.webviewJsBridge = window.webviewJsBridge || { addHandler: (a, b) => { } };

// This needs to be first
const eventEmitter = new Emitter();

// Init Common Services
const commonMethods = new CommonMethods(eventEmitter);
// Global Tracking Service
const trackingService = new TrackingService(commonMethods);

if (
    typeof window.loadedlog === 'object' &&
    window.loadedlog !== null &&
    window.console
) {
    window.console.log('ANTENNE JS loaded (OAuth)', window.loadedlog);
}

// Load Scripts based on CMP-Consents
new CmpVendorScriptLoader(commonMethods);

// Handle Navigation between pages (Turbo)
const navigationHandler = new NavigationHandler(commonMethods, trackingService, eventEmitter);

new Form(commonMethods, navigationHandler);
new WebAuthn(commonMethods, navigationHandler);

new BrushHeadlines(commonMethods, navigationHandler);

document.documentElement.classList.remove('u-no-js');
document.documentElement.classList.add('u-supports-js');
OldieAntenneColorRotation(navigationHandler);
